function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.0016,
  cy: 14.4351,
  r: 7.4406,
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99512 35.0063C6.99512 30.6558 10.5228 27.1281 14.8734 27.1281H19.3955",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7583 31.5049C36.7583 34.4111 34.4123 36.7571 31.5061 36.7571C28.5999 36.7571 26.2539 34.4111 26.2539 31.5049C26.2539 28.5987 28.5999 26.2527 31.5061 26.2527C34.4123 26.2527 36.7583 28.5987 36.7583 31.5049Z",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.792 35.2181L35.2168 27.7932",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgOfferCancelledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = React.forwardRef(SvgOfferCancelledIcon);
export default __webpack_public_path__ + "static/media/offer_cancelled_icon.e89842cd.svg";
export { ForwardRef as ReactComponent };